/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Contact_Add_TitleInputs */

const en_case_contact_add_title = /** @type {(inputs: Case_Contact_Add_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add contact`)
};

const pt_br2_case_contact_add_title = /** @type {(inputs: Case_Contact_Add_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar contato`)
};

/**
* | output |
* | --- |
* | "Add contact" |
*
* @param {Case_Contact_Add_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_contact_add_title = /** @type {((inputs?: Case_Contact_Add_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Contact_Add_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_contact_add_title(inputs)
	return pt_br2_case_contact_add_title(inputs)
});